/**
 * The only module in this repository that imports `zod`, and the reason is 141 KB of translations
 * nobody reads.
 *
 * `zod`'s entry point ends with `export * as locales from "../locales/index.js"` — around fifty
 * locale modules, one per language it can render validation messages in. Turbopack cannot drop them
 * behind `import { z } from 'zod'`, because `z` is the whole module namespace: reaching `z.string`
 * means keeping everything reachable through `z`, `z.locales` included. Measured, that was 141 KB
 * minified on `/nl/contact`, `/nl/aanmelden` and `/nl/inloggen` — the three pages a visitor lands on
 * with the intent this site exists for.
 *
 * Named imports have no such problem, so this module takes them and hands back an object with the
 * same shape the call sites already used. `z.string()` still reads as `z.string()`; what changed is
 * that the bundler can now see it is the only thing asked for. Measured after: 42 KB gzip off
 * `/nl/aanmelden`, 19 KB off `/nl/contact`.
 *
 * Adding a validator means adding its name here. That is the whole maintenance cost, and it is the
 * point — an import that pulls the barrel back in would undo this silently.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { boolean, literal, object, string, ZodIssueCode } from 'zod'

export const z = { boolean, literal, object, string, ZodIssueCode }

/** `z.infer<T>` under a name that survives the namespace not being imported. */
export type { infer as Infer } from 'zod'
